
const InputElement = (props) => {
	let required = props.required? true : false
	let type = props.type? props.type : 'text'
   	return (
        <p>
            <label>{props.label}{required && <sup>*</sup>}</label>
            <input name={props.name} type={type} value={props.value} onChange={props.handleChange}></input>
        </p>
   )
}

export default InputElement